// src/pages/competitions/MainPage.jsx

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useData } from "@/contexts/DataContext";
import { useAuth } from "@/contexts/AuthContext";
import { fetchCompetitions } from "@/services/apiService";
import HeroSection from "@/components/main/HeroSection";
import AllCompetitionsSection from "@/components/main/AllCompetitionsSection";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogCancel,
  AlertDialogAction,
} from "@/components/ui/alert-dialog";

const MainPage = () => {
  const { competitions, setCompetitions, loading, user } = useData();
  const { handleLogout } = useAuth();
  const [isLoading, setIsLoading] = useState(loading);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const token = sessionStorage.getItem("accessToken");

    if (user && token && competitions.length === 0) {
      setIsLoading(true);
      fetchCompetitions()
        .then((data) => {
          setCompetitions(data);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching competitions:", error);
          setIsLoading(false);
        });
    }
  }, [user, setCompetitions, competitions.length]);

  return (
    <div className="w-full bg-stone-brown">
    <div className="pt-[4.25rem]">
      {/* Hero Section */}
      <HeroSection />

      {/* Grid Section */}
      <div className="py-8">
        {isLoading ? (
          <h3 className="text-center text-lg text-white font-semibold">
            Loading Competitions...
          </h3>
        ) : (
          <AllCompetitionsSection competitions={competitions} />
        )}
      </div>
    </div>

      {/* Logout Confirmation */}
      <AlertDialog open={showPopup} onOpenChange={setShowPopup}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Are you sure you want to Logout?</AlertDialogTitle>
            <AlertDialogDescription>This action cannot be undone.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>No</AlertDialogCancel>
            <AlertDialogAction onClick={handleLogout}>Yes</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};

export default MainPage;